import { BaseDto } from './base.dto';

export class ModifierOutOfStockDto extends BaseDto {
  menuId: number;
  merchantId: number;
  productId: number;
  modifierId: number;
  isOutOfStock: boolean;
}
